import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io';
import logo from '../assets/images/logo.png';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col footer-about">
              <Link to="/" className="footer-logo">
                <img src={logo} alt="Notary Public Logo" className="logo-img" />
              </Link>
              <p>
                Professional notary services in Federal Way, WA. Fast, reliable, and convenient
                notarization for all your legal documents.
              </p>
              <div className="footer-social">
                <a href="#" className="social-link">
                  <FaFacebook />
                </a>
                <a href="#" className="social-link">
                  <FaTwitter />
                </a>
                <a href="#" className="social-link">
                  <FaLinkedin />
                </a>
              </div>
            </div>
            <div className="footer-col footer-links">
              <h3 className="footer-title">Quick Links</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/online-notarization">Online Notarization</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
            <div className="footer-col footer-services">
              <h3 className="footer-title">Our Services</h3>
              <ul>
                <li>General Notary Services</li>
                <li>Real Estate Documents</li>
                <li>Online Notarization</li>
                <li>Legal Documents</li>
                <li>Mobile Notary Services</li>
              </ul>
            </div>
            <div className="footer-col footer-contact">
              <h3 className="footer-title">Contact Us</h3>
              <ul>
                <li>
                  <FaMapMarkerAlt /> 1305 S 312th St suite 202, Federal Way, WA 98003
                </li>
                <li>
                  <FaPhone /> <a href="tel:2065664676">(206) 566-4676</a>
                </li>
                <li>
                  <IoLogoWhatsapp />{' '}
                  <a href="https://wa.me/12065664676">WhatsApp: (206) 566-4676</a>
                </li>
                <li>
                  <FaEnvelope />{' '}
                  <a href="mailto:info@notarypublic.com">info@notarypublic.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} Notary Public. All Rights Reserved. |{' '}
            <Link to="/privacy-policy">Privacy Policy</Link> |{' '}
            <Link to="/terms">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;